// Static site content. Edit this file to update services, projects, solutions, or contact information.
export const SERVICES = [
  {
    "id": "ee84844f-2577-49b4-b4be-9e57356f9dd7",
    "slug": "endustriyel-elektrik",
    "order": 1,
    "number": "01",
    "title": "Endüstriyel Elektrik Sistemleri",
    "icon": "Zap",
    "image": "https://images.unsplash.com/photo-1566417110104-cd4f94af0fb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "Alçak ve orta gerilim güç dağıtımından topraklamaya kadar endüstriyel tesisler için uçtan uca elektrik altyapısı.",
    "description": "Üretim tesisleri ve endüstriyel yapılar için güç dağıtım sistemlerini keşiften devreye almaya kadar tasarlıyor ve kuruyoruz. Enerji verimliliği, süreklilik ve güvenlik odağıyla, ölçeklenebilir ve standartlara uygun elektrik altyapıları geliştiriyoruz.",
    "capabilities": [
      "AG / OG güç dağıtım sistemleri",
      "Trafo merkezleri ve enerji odaları",
      "Aydınlatma ve kuvvet tesisatı",
      "Topraklama ve yıldırımdan korunma",
      "Kompanzasyon ve enerji kalitesi",
      "Kablo tavaları ve busbar sistemleri"
    ],
    "applications": [
      "Üretim tesisleri",
      "Lojistik ve depo yapıları",
      "OSB fabrikaları",
      "Enerji ve altyapı projeleri"
    ]
  },
  {
    "id": "2dcd928c-cfce-47f5-a8a4-1e4683950be2",
    "slug": "elektrik-taahhut",
    "order": 2,
    "number": "02",
    "title": "Elektrik Taahhüt",
    "icon": "HardHat",
    "image": "https://images.unsplash.com/photo-1758101755915-462eddc23f57?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "Projelendirmeden anahtar teslim uygulamaya kadar profesyonel elektrik taahhüt hizmetleri.",
    "description": "Elektrik taahhüt projelerini planlama, satın alma, uygulama ve devreye alma aşamalarında bütünsel bir mühendislik disipliniyle yönetiyoruz. Anahtar teslim yaklaşımımızla projeleri zamanında, bütçesinde ve standartlara uygun şekilde teslim ediyoruz.",
    "capabilities": [
      "Anahtar teslim elektrik projeleri",
      "Saha keşfi ve fizibilite",
      "İş programı ve proje yönetimi",
      "Kabul ve devreye alma testleri",
      "As-built dokümantasyon",
      "Mevzuata uygunluk ve raporlama"
    ],
    "applications": [
      "Endüstriyel tesis kurulumları",
      "Kapasite artırım projeleri",
      "Tesis modernizasyonu",
      "Altyapı yenileme"
    ]
  },
  {
    "id": "f9bd656d-6e18-41be-8ffc-2fb0aa13b061",
    "slug": "endustriyel-otomasyon",
    "order": 3,
    "number": "03",
    "title": "Endüstriyel Otomasyon",
    "icon": "Cpu",
    "image": "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "PLC, HMI ve SCADA tabanlı kontrol sistemleriyle üretim verimliliğini ve izlenebilirliği artırıyoruz.",
    "description": "Makine ve proseslerinizi güvenilir kontrol sistemleriyle otomatikleştiriyoruz. PLC programlama, HMI/SCADA tasarımı ve saha enstrümantasyonu ile verimliliği artıran, izlenebilir ve sürdürülebilir otomasyon çözümleri sunuyoruz.",
    "capabilities": [
      "PLC yazılım ve donanım tasarımı",
      "HMI / SCADA uygulamaları",
      "Proses ve makine otomasyonu",
      "Motor ve sürücü (VFD) sistemleri",
      "Endüstriyel haberleşme ağları",
      "Uzaktan izleme ve veri toplama"
    ],
    "applications": [
      "Üretim hatları",
      "Proses tesisleri",
      "Su ve enerji yönetimi",
      "Paketleme ve malzeme taşıma"
    ]
  },
  {
    "id": "a28bb5c1-4770-4596-865c-a9d719730024",
    "slug": "pano-sistemleri",
    "order": 4,
    "number": "04",
    "title": "Elektrik Pano Sistemleri",
    "icon": "Server",
    "image": "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "Standartlara uygun güç ve kontrol panolarının mühendisliği, üretimi ve testi.",
    "description": "Alçak gerilim dağıtım panolarından otomasyon kontrol panolarına kadar, projeye özel pano çözümlerini tasarlıyor ve üretiyoruz. Termal analiz, kablolama disiplini ve test süreçleriyle güvenli ve uzun ömürlü panolar sunuyoruz.",
    "capabilities": [
      "Ana dağıtım (MDP) panoları",
      "Motor kontrol merkezleri (MCC)",
      "Kompanzasyon panoları",
      "PLC / otomasyon kontrol panoları",
      "Senkronizasyon ve jeneratör panoları",
      "Pano test ve devreye alma"
    ],
    "applications": [
      "Fabrika elektrik odaları",
      "Saha kontrol istasyonları",
      "Enerji dağıtım noktaları",
      "Proses kontrol sistemleri"
    ]
  },
  {
    "id": "1d32a383-ba28-4561-9148-8750d5ffa117",
    "slug": "projelendirme-muhendislik",
    "order": 5,
    "number": "05",
    "title": "Projelendirme & Mühendislik",
    "icon": "PencilRuler",
    "image": "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "Elektrik ve otomasyon projelerinin tasarımı, hesapları ve teknik dokümantasyonu.",
    "description": "Fikir aşamasından uygulamaya kadar mühendislik çözümleri üretiyoruz. Yük hesapları, tek hat şemaları, otomasyon mimarileri ve teknik şartnamelerle projelerinizi sağlam bir mühendislik temeli üzerine kuruyoruz.",
    "capabilities": [
      "Elektrik proje tasarımı",
      "Yük ve kısa devre hesapları",
      "Tek hat ve pano şemaları",
      "Otomasyon mimari tasarımı",
      "Teknik şartname hazırlama",
      "Danışmanlık ve fizibilite"
    ],
    "applications": [
      "Yeni tesis yatırımları",
      "Kapasite planlaması",
      "Enerji verimliliği projeleri",
      "Sistem entegrasyonu"
    ]
  },
  {
    "id": "1ec3856b-024f-45a1-9d07-86f4fa1654ca",
    "slug": "bakim-teknik-servis",
    "order": 6,
    "number": "06",
    "title": "Bakım & Teknik Servis",
    "icon": "Wrench",
    "image": "https://images.unsplash.com/photo-1720036237584-7fd0f37db499?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "short_desc": "Periyodik bakım, arıza müdahale ve satış sonrası teknik destek hizmetleri.",
    "description": "Sistemlerinizin çalışma sürekliliğini desteklemek için planlı bakım, arıza tespit ve müdahale hizmetleri ile uzun vadeli teknik destek sunuyoruz. Planlı bakım yaklaşımıyla duruş risklerini azaltmayı hedefliyoruz.",
    "capabilities": [
      "Periyodik ve önleyici bakım",
      "Arıza tespit ve müdahale",
      "Termal kamera ölçümleri",
      "Yedek parça ve revizyon",
      "Sistem iyileştirme",
      "Satış sonrası teknik destek"
    ],
    "applications": [
      "Üretim tesisleri",
      "Pano ve trafo bakımı",
      "Otomasyon sistem desteği",
      "Acil müdahale"
    ]
  }
];

export const PROJECTS = [
  {
    "id": "909bde5b-edda-44da-9adc-f260dafa907b",
    "slug": "endustriyel-tesis-elektrifikasyonu",
    "order": 1,
    "title": "Endüstriyel Tesis Elektrifikasyonu",
    "category": "Elektrik",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "AG/OG güç dağıtımı, trafo merkezi ve aydınlatma tesisatı dahil anahtar teslim elektrifikasyon.",
    "description": "Büyük ölçekli bir üretim tesisi için güç dağıtım altyapısının tasarımı ve uygulaması. Enerji odaları, kablo altyapısı ve kompanzasyon sistemleri projelendirilerek devreye alınmıştır. Bu bir örnek projedir; gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Endüstriyel Elektrik",
      "Projelendirme",
      "Elektrik Taahhüt"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1566417110104-cd4f94af0fb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  },
  {
    "id": "1c00fde3-957d-4654-9f90-bcfcefc4d91b",
    "slug": "fabrika-otomasyonu",
    "order": 2,
    "title": "Fabrika Otomasyonu",
    "category": "Otomasyon",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "PLC/SCADA tabanlı üretim otomasyonu ve robotik hücre entegrasyonu.",
    "description": "Üretim hattı için PLC kontrol mimarisi, SCADA izleme ve robotik entegrasyonun gerçekleştirildiği örnek bir otomasyon projesi. Gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Endüstriyel Otomasyon",
      "Pano Sistemleri"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  },
  {
    "id": "a7c06154-d85f-48b6-a8d5-35075de896dd",
    "slug": "elektrik-dagitim-sistemleri",
    "order": 3,
    "title": "Elektrik Dağıtım Sistemleri",
    "category": "Elektrik",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "Orta gerilim dağıtım, trafo ve koruma sistemleri.",
    "description": "Endüstriyel bölge için orta gerilim dağıtım ve koruma sistemlerinin kurulduğu örnek proje. Gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Endüstriyel Elektrik",
      "Projelendirme"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1509390144018-eeaf65052242?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1509390221805-d1c887a72a00?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1566417110104-cd4f94af0fb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  },
  {
    "id": "032df025-1bec-431d-b7d1-c1f1ce26ed70",
    "slug": "kontrol-panosu-projesi",
    "order": 4,
    "title": "Kontrol Panosu Projesi",
    "category": "Pano",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "Motor kontrol merkezi ve otomasyon panolarının tasarımı ve üretimi.",
    "description": "Proje bazlı motor kontrol merkezi (MCC) ve PLC kontrol panolarının mühendisliği, üretimi ve testinin yapıldığı örnek proje. Gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Pano Sistemleri",
      "Endüstriyel Otomasyon"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1566417110104-cd4f94af0fb3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1720036237584-7fd0f37db499?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  },
  {
    "id": "09fa97d4-6bb3-4cb0-a77e-e0e68a3b156d",
    "slug": "uretim-hatti-otomasyonu",
    "order": 5,
    "title": "Üretim Hattı Otomasyonu",
    "category": "Otomasyon",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1610891015188-5369212db097?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "Sürücü sistemleri, senkron kontrol ve hat izleme.",
    "description": "Sürekli üretim hattı için motor-sürücü senkronizasyonu ve SCADA tabanlı izleme sisteminin kurulduğu örnek proje. Gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Endüstriyel Otomasyon",
      "Bakım / Teknik Servis"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1610891015188-5369212db097?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  },
  {
    "id": "46509eb5-4495-42dd-bd3b-3c67a78e8e0a",
    "slug": "proses-otomasyonu",
    "order": 6,
    "title": "Proses Tesisi Otomasyonu",
    "category": "Mühendislik",
    "location": "[Şehir — düzenlenebilir]",
    "year": "[Yıl]",
    "client": "[Müşteri — düzenlenebilir]",
    "cover": "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    "scope": "Proses kontrol mimarisi, enstrümantasyon ve enerji yönetimi.",
    "description": "Proses tesisi için kontrol mimarisi, saha enstrümantasyonu ve enerji izleme sistemlerinin tasarlandığı örnek mühendislik projesi. Gerçek proje verileri sağlandığında güncellenecektir.",
    "services": [
      "Projelendirme",
      "Endüstriyel Otomasyon"
    ],
    "gallery": [
      "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1717386255773-1e3037c81788?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
      "https://images.unsplash.com/photo-1563456019560-2b37aa7ad890?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
    ]
  }
];

export const SOLUTIONS = [
  {
    "id": "171dd3d5-da3d-46d1-aff0-965b4cd7de55",
    "order": 1,
    "title": "PLC & HMI Sistemleri",
    "icon": "Cpu",
    "description": "Güvenilir programlanabilir kontrol ve operatör arayüzü çözümleriyle makine ve proseslerin hassas kontrolü."
  },
  {
    "id": "567712fc-98a0-4ee0-a287-38907969d604",
    "order": 2,
    "title": "SCADA Sistemleri",
    "icon": "MonitorDot",
    "description": "Merkezi izleme, veri toplama ve raporlama ile tesis genelinde gerçek zamanlı görünürlük."
  },
  {
    "id": "d17bde4d-bb4d-4597-89e2-b72754a459d9",
    "order": 3,
    "title": "Proses Otomasyonu",
    "icon": "Workflow",
    "description": "Sürekli ve kesikli proseslerin optimize edilmiş, tekrarlanabilir ve güvenli otomasyonu."
  },
  {
    "id": "28424c88-764d-4dc9-9d65-79533235a369",
    "order": 4,
    "title": "Makine Otomasyonu",
    "icon": "Cog",
    "description": "Özel makine ve üretim hücrelerinin uçtan uca kontrol ve entegrasyonu."
  },
  {
    "id": "bd3189ad-b91e-41b7-a002-61a9a8033a1a",
    "order": 5,
    "title": "Motor & Sürücü Sistemleri",
    "icon": "Gauge",
    "description": "VFD ve soft-starter uygulamalarıyla enerji verimli ve kontrollü tahrik sistemleri."
  },
  {
    "id": "be267a36-9197-4a26-b96e-dd4815a23885",
    "order": 6,
    "title": "Enerji Yönetimi",
    "icon": "BatteryCharging",
    "description": "Enerji izleme, kompanzasyon ve tüketim optimizasyonu ile maliyet ve verimlilik kontrolü."
  },
  {
    "id": "35040f0c-c16d-4799-9b02-b62b86717080",
    "order": 7,
    "title": "Endüstriyel Kontrol",
    "icon": "SlidersHorizontal",
    "description": "Saha enstrümantasyonu ve kontrol sistemleriyle güvenilir endüstriyel operasyon."
  },
  {
    "id": "338111ce-9205-4e87-a3ff-7799f2fae2fc",
    "order": 8,
    "title": "Elektrik Dağıtım",
    "icon": "Zap",
    "description": "AG/OG dağıtım, koruma ve topraklama ile güvenli ve sürekli enerji altyapısı."
  }
];

export const SETTINGS = {
  "hero_eyebrow": "ENDÜSTRİYEL ELEKTRİK & OTOMASYON",
  "hero_title": "Endüstriyel gücü\nmühendislikle\nbuluşturuyoruz.",
  "hero_subtitle": "Elektrik, otomasyon ve mühendislik projelerinde keşiften devreye almaya kadar yenilikçi, güvenilir ve sürdürülebilir çözümler.",
  "company_phone": "+90 545 764 9088",
  "company_email": "isa@sistemmuhendislik.com",
  "company_address": "Karacaoğlan Mah. 6219 Sk. No: 2 İç Kapı No: 1, Bornova / İzmir",
  "working_hours": "08:30 – 17:00",
  "whatsapp_number": "905457649088",
  "map_embed": "",
  "stats": [
    {
      "label": "Tamamlanan Proje",
      "value": "[—]"
    },
    {
      "label": "Uzmanlık Alanı",
      "value": "6"
    },
    {
      "label": "Yıllık Deneyim",
      "value": "[—]"
    },
    {
      "label": "Teknik Destek",
      "value": "Satış Sonrası"
    }
  ]
};

